import React from 'react';
const PipeOpenEnd2Icon = ({ width = 64, height = 64 }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 112.5 56.195">
      <defs>
        <linearGradient id={`${id}_1`} gradientUnits="userSpaceOnUse" x1="245.9395" y1="-107.1526" x2="245.9395" y2="5.3474" gradientTransform="matrix(0 -1 1 0 107.1531 283.3479)">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.18" stopColor="#949494" />
          <stop offset="0.5" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#656565" />
        </linearGradient>
        <radialGradient id={`${id}_2`} cx="463.4619" cy="-43.4514" r="37.8042" gradientTransform="matrix(0 -0.5005 1.5015 0 121.4922 250.845)" gradientUnits="userSpaceOnUse">
          <stop offset="0.01" stopColor="#4C4C4C" />
          <stop offset="0.68" stopColor="#ABABAB" />
          <stop offset="0.82" stopColor="#F4F4F4" />
          <stop offset="1" stopColor="#585858" />
        </radialGradient>
        <linearGradient id={`${id}_3`} gradientUnits="userSpaceOnUse" x1="249.9424" y1="-50.4031" x2="278.9893" y2="-50.4031" gradientTransform="matrix(0 -1 1 0 107.1531 283.3479)">
          <stop offset="0" stopColor="#323232" />
          <stop offset="0.56" stopColor="#000000" />
          <stop offset="1" stopColor="#323232" />
        </linearGradient>
      </defs>
      <path fill={`url(#${id}_1)`} d="M0,56.196V18.62h112.5v37.575H0z" />
      <ellipse fill={`url(#${id}_2)`} cx="56.25" cy="18.882" rx="56.25" ry="18.938" />
      <path fill={`url(#${id}_3)`} d="M105.838,18.882c0,19.364-98.176,19.364-98.176,0S105.838-0.482,105.838,18.882z" />
    </svg>
  );
};
export default PipeOpenEnd2Icon;
